import React, { useEffect } from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/content";
import SectionTitle from "../components/site/SectionTitle";
import GeometricDivider from "../components/site/GeometricDivider";

const GALLERY = [
  { label: "Dargah arches at dawn", url: "https://images.unsplash.com/photo-1542816417-0983c9c9ad53?auto=format&fit=crop&w=1200&q=80", alt: "Ornate mihrab arches of a dargah" },
  { label: "Sufi calligraphy & lanterns", url: "https://images.unsplash.com/photo-1564769625392-651b2c4f6552?auto=format&fit=crop&w=1200&q=80", alt: "Brass lanterns and calligraphy" },
  { label: "Sacred geometry", url: "https://images.unsplash.com/photo-1604999333679-b86d54738315?auto=format&fit=crop&w=1200&q=80", alt: "Islamic geometric patterns" },
];

export default function Followers() {
  useEffect(() => { document.title = "Followers (Murids) — Hazrat Sufi Sarkar"; }, []);
  return (
    <div data-testid="followers-page">
      <section className="pattern-emerald text-ivory pt-32 pb-24" data-testid="followers-hero">
        <div className="container-page text-center">
          <span className="text-[11px] uppercase tracking-[0.32em] text-gold">The Murids</span>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 leading-tight">Our Followers</h1>
          <p className="text-ivory/80 mt-5 max-w-2xl mx-auto leading-relaxed">
            A global community carrying forward the message of love, tolerance, and unity — from Kerala to every corner of the world.
          </p>
        </div>
      </section>

      <section className="section-pad" data-testid="followers-testimonials">
        <div className="container-page">
          <SectionTitle eyebrow="Devotee Voices" title="Answered Prayers, Quiet Peace" />
          <GeometricDivider />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t, i) => (
              <figure key={t.name} data-testid={`follower-${i}`} className="card-soft p-8 reveal" style={{ transitionDelay: `${i * 60}ms` }}>
                <Quote className="text-gold mb-4" size={24} />
                <blockquote className="font-serif text-lg text-emerald leading-snug">"{t.text}"</blockquote>
                <figcaption className="mt-5 text-sm">
                  <span className="text-charcoal font-semibold">{t.name}</span>
                  <span className="text-charcoal-muted"> · {t.location}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="pattern-bg section-pad" data-testid="followers-gallery">
        <div className="container-page">
          <SectionTitle eyebrow="Gatherings & Urs" title="Moments in the Light" />
          <div className="grid md:grid-cols-3 gap-6">
            {GALLERY.map((g, i) => (
              <div key={g.label} data-testid={`gallery-${i}`} className="relative aspect-[4/5] overflow-hidden rounded-lg border border-gold/30 reveal" style={{ transitionDelay: `${i * 80}ms` }}>
                <img src={g.url} alt={g.alt} className="h-full w-full object-cover transition-transform duration-1000 hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-emerald-deep/85 via-emerald-deep/10 to-transparent" />
                <div className="absolute bottom-5 left-5 right-5">
                  <p className="calligraphy text-gold text-sm">{g.label}</p>
                  <p className="font-serif text-xl text-ivory mt-1">{g.alt}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
